import React from "react";

const OrgSettingsSkeleton: React.FC = () => (
  <div className="bg-gray-100 h-full overflow-y-auto animate-pulse">
    <div className="w-full mx-auto py-8 px-4 sm:py-12 sm:px-10">
      {/* back button */}
      <div className="h-4 bg-gray-200 rounded w-24 mb-6" />
      {/* title */}
      <div className="h-7 bg-gray-200 rounded w-48 mb-8" />
      {/* sections */}
      {[...Array(3)].map((_, i) => (
        <div key={i} className="bg-white rounded-lg shadow p-6 mb-6">
          <div className="h-4 bg-gray-200 rounded w-32 mb-4" />
          {[...Array(3)].map((_, j) => (
            <div
              key={j}
              className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0"
            >
              <div className="space-y-1.5">
                <div className="h-4 bg-gray-200 rounded w-40" />
                <div className="h-3 bg-gray-200 rounded w-64" />
              </div>
              <div className="h-6 w-11 bg-gray-200 rounded-full flex-shrink-0" />
            </div>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default OrgSettingsSkeleton;
